/* global axios */

class DealAutomationRulesAPI {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/deal_automation_rules`);
  }

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/deal_automation_rules/${id}`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/deal_automation_rules`, {
      deal_automation_rule: payload,
    });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/deal_automation_rules/${id}`, {
      deal_automation_rule: payload,
    });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/deal_automation_rules/${id}`);
  }

  clone(accountId, id) {
    return axios.post(`/api/v1/accounts/${accountId}/deal_automation_rules/${id}/clone`);
  }
}

export default new DealAutomationRulesAPI();
